import styled from 'styled-components';

export const UnsetDiv = styled.div`
  a {
    all: unset;
  }
`;
